// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsScopes = {
  scopesTitle: "Scopes",
  scopes: {
    mine: "Mine",
    shared_with_me: "Shared with Me",
    public: "Public",
    all: "All",
  },
} as const;
